import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRoutes } from './apiroutes';
import { ChatToken } from '../models/chat';

@Injectable({
  providedIn: 'root'
})
export class ScribbleService {

  base_url = ApiRoutes.Scribble;
  notes: [] = [];

  constructor(private http: HttpClient) { }

  getNotes(token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + token,
      }),
    };
    let url = `${this.base_url}?page=1&page_size=50`;
    return this.http.get(url, httpOptions);
  }

  createNote(note: {}, token) {
    return this.http.post(this.base_url, note, {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + token,
      }),
      observe: 'response'
    });
  }

  updateNote(id: string, note: {}, token) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + token,
      }),
    };
    return this.http.put(this.base_url + id + '/', note, httpOptions);
  }

  deleteNote(id: string, token) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + token,
      }),
    };
    return this.http.delete(this.base_url + id + '/', httpOptions);
  }
}
